<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">Diversion Books</span><br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1004<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Copyright © 1981 by Martha Kay Renfroe</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</span></p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a>.</span></p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">First Diversion Books edition July 2013</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">ISBN: </span><span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em; font-family: 'Liberation Serif', serif; text-align: justify;">978-1-62681-097-6</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h3>
	Also by M.K. Wren</h3>
<p class="first" style="text-align: center;">
<span href="#/Text/chap159682" title="Link target outside of Sample">A Gift Upon the Shore</span></p>
<p class="first" style="text-align: center;">
<em><strong>The Phoenix Legacy</strong></em><br/>
<span href="#/Text/chap159682" title="Link target outside of Sample"><span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">Shadow of the Swan (Book Two of the Phoenix Legacy)</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">House of the Wolf (Book Three of the Phoenix Legacy)</span></span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<p style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">This book is dedicated in gratitude to Dwight V. Swain, a man with a rare talent for teaching well an art that defies teaching.</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<p class="nonindent1">
	PHOENIX MEMFILES: DEPT HUMAN SCIENCES:<br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">HISTORY(HS/H)</span></p>
<p class="nonindent1">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">SUBFILE: WAR OF THE TWIN PLANETS (3208–3210):</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">PELADEEN REPUBLIC: LETTAPE #61:</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">FROM LORD ELOR USSHER PELADEEN</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">TO DR. ANDREAS RIIS</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">I JANUAR 3210</span></p>
<p class="nonindent1">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">DOC LOC #819/8–232016–1618–122016 #61: 32116/118–113210</span></p>
<p class="first">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">My dear Andreas,</span></p>
<p>
	I’m touched by your appeal to join you “underground,” and I admit I was tempted; it isn’t easy to face the prospect of one’s imminent death. But I took the Crest Ring of Peladeen from my father’s dead hand, and I swore the Oath of Allegiance to the Republic. These are both life vows, and I will not betray them.</p>
<p>
	I must also decline for another reason. The Concord cannot let me live. The House of Peladeen must be destroyed or the memory of the Republic will continue to be a thorn in its side. The Directors will demand my corpse. If they don’t find it, they’ll hunt me down even into the remotest parts of the Centauri System, and they might discover your existence in the process. The survival of the Society of the Phoenix is too important for me to justify that risk.</p>
<p>
	I considered sending the Lady Manir and our son, Predis, to you for sanctuary. I have no secrets from Manir, and she knows about the Phoenix. However, she refused this alternative as she refused to seek sanctuary of her relatives in the House of Kalister on Terra, which, as she said, would necessitate a public repudiation of me and the Republic. I would urge her to do so if it would save her life, but she’s a proud woman, and beyond that knows full well that the Kalister aren’t likely to risk the ire of the other Lords of the Concord to protect a very distant cousin so unfortunate as to be my wife.</p>
<p>
	Manir might have considered the sanctuary of the Phoenix if she thought our son could be saved, but she sees no hope for him. The Concord can’t let Predis live for the same reasons it can’t let me live. He’s only a child, and it seems doubly cruel, but he might grow up to become the focus of future revolt, and so he must die, as I must, for the Concord’s peace of mind.</p>
<p>
	I speak too much of death, but you’ll understand that. The end is closer than I thought when I last ’taped you. Pollux is lost, and by the time this reaches you, I’ll have retreated to the Helen estate on Castor. That planet is less hospitable to human life, and invading armies, than Pollux. This may be my last opportunity to communicate with you, Andreas. I have no solemn words to leave you, but I’m offering something more useful—the pragmatic fuel of existence, money. My messenger will be carrying a case with a lock keyed to your voice. Only part of this last bequest is in cash; I’ve had no opportunity to gather much in ’cords, and Republic drakos will soon be worthless. Most of this bequest consists of jewelry and unset stones; its total value is probably in excess of five million ’cords.</p>
<p>
	I’m relieved to hear that the installation of your facilities is so near completion. It comes none too soon. I’ve assigned my chief ministrator, Master Hamner, the task of checking the Republic Archives to be sure no record of the original geophysical station remains in the memfiles. I have complete faith in Master Hamner; he will not fail you.</p>
<p>
	Andreas, we won’t meet again, but I face defeat without despair knowing the Phoenix lives. I will be the last Lord of the House of Peladeen, and if the Republic goes down in history bearing the Peladeen name, I doubt the Concord will let it be spoken with pride. The Society of the Phoenix is my only hope. My hope for humankind, and my hope for immortality. If the time ever comes, Andreas, when the Phoenix rises from the ashes of this disaster like its namesake, let it be known that the Lord Elor had some part in its birthing.</p>
<p class="double">
	May the Holy Mezion and the All-God smile on this fledgling. I live and shall die in that hope.</p>
<p style="text-align: right;">
	Elor, the Lord Ussher Peladeen</p>
<p style="text-align: right;">
	Leda, Pollux 1 Januar 3210</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004copyright.vue?7ba9174e